<template>
	<div>
		<v-btn
			v-if="psychologist.visible"
			class="button"
			color="primary"
			outlined
			tile
			@click="isDialogOpen = true"
		>
			<p>Voir le contact pour prendre rendez-vous</p>
		</v-btn>
		<p
			v-else
			class="no-visible"
		>
			Aucune disponibilité actuellement
		</p>

		<DialogBox
			v-model="isDialogOpen"
			hide-actions
			title="Pour prendre rendez-vous"
			width="500px"
		>
			<section>
				<p v-if="!hasContactInfo">
					Le psychologue n'a pas fourni d'information de contact
				</p>

				<div v-else>
					<IconText
						v-if="psychologist.display_phone && psychologist.phone"
						:icon="phoneIcon"
						:text="psychologist.phone"
						icon-color="red"
					/>
					<IconText
						v-if="psychologist.display_email && psychologist.email"
						:icon="emailIcon"
						:text="psychologist.email"
						icon-color="red"
					/>
					<IconText
						v-if="psychologist.website"
						:icon="webIcon"
						:text="psychologist.website"
						icon-color="red"
					/>
				</div>
			</section>
		</DialogBox>
	</div>
</template>

<script lang="ts">
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import { mdiEmailOutline, mdiPhone, mdiWeb } from '@mdi/js';
	import IconText from '@/components/search-psychologist/result-section/card-content/IconText.vue';
	import DialogBox from '@cnamts/vue-dot/src/elements/DialogBox';
	import { SearchPsychologist } from '@/types/models/SearchPsychologist';

	/**
	 * Bouton de consultation d'un psychologue
	 */
	@Component({
		components: { IconText, DialogBox }
	})
	export default class ConsultButton extends Vue {
		@Prop({ default: {} })
		readonly psychologist!: SearchPsychologist;

		// Icônes
		readonly phoneIcon = mdiPhone;
		readonly emailIcon = mdiEmailOutline;
		readonly webIcon = mdiWeb;

		// Est-ce que la boite de dialogue est ouverte ?
		isDialogOpen = false;

		/**
		 * Le psychologue a-t-il des informations de contact ?
		 */
		get hasContactInfo(): boolean {
			const hasPhone = this.psychologist.display_phone && !!this.psychologist.phone;
			const hasEmail = this.psychologist.display_email && !!this.psychologist.email;
			const hasWebsite = !!this.psychologist.website;

			return hasPhone || hasEmail || hasWebsite;
		}
	}
</script>

<style lang="css" scoped>
p {
	margin: 0 !important;
}

.no-visible {
	background-color: #eeeeee;
	width: fit-content;
	padding: 0 10px;
	font-weight: bold;
	border: 1px solid black;
}

.button {
	width: fit-content;
	padding: 5px;
	height: auto !important;
	max-width: 100%;
	white-space: normal;
}
</style>
